// extracted by mini-css-extract-plugin
module.exports = {"companyInfo":"style_companyInfo__3vNFO","companyLogo":"style_companyLogo__2dDdi","companyName":"style_companyName__1v7GL","spinning":"style_spinning__YoMeP"};